import React, { useContext, useEffect } from 'react';
import 'twin.macro';
import { useLocation } from 'react-router-dom';
import { CommentsContext, UserContext } from '../context/';
import { CommentsSorting, CommentsWrapper, ModeratorButtons, InfiniteScrollCommentsList } from './';
import { CommentForm } from '../form';
import { TitleRow } from '../text';
import { Button } from '../button';
import { pluralize, scrollToLocation } from '../../lib/helpers';
import { CommentIcon, ArrowIcon } from 'icons';

export const AddCommentButton = ({ ...restProps }) => {
  const { commentsList, setShowAllComments } = useContext(CommentsContext);
  return (
    <>
      {commentsList.length > 10 && (
        <Button
          label='reaguren'
          primary
          iconProps={{ Type: CommentIcon, color: 'dark', size: 'medium' }}
          tw='mx-auto mb-3'
          onClick={() => {
            setShowAllComments(true);
            setTimeout(() => scrollToLocation('form'), 500);
          }}
          {...restProps}
        />
      )}
    </>
  );
};

const GoToTopOfComments = () => (
  <Button
    label='naar boven'
    secondary
    iconProps={{ Type: ArrowIcon, size: 'medium' }}
    tw='mx-auto'
    onClick={() => scrollToLocation('commentsTop')}
  />
);

const RightBlock = () => (
  <div tw='flex items-center h-full justify-center gap-2'>
    <CommentsSorting menuRight />
  </div>
);

export const CommentsList = ({ itemId }) => {
  const {
    commentsList,
    commentsData,
    openComments,
    lastAddedComment,
    setLastAddedComment,
    showAllComments,
  } = useContext(CommentsContext);

  const { user } = useContext(UserContext);
  const userCanModerate = user && user.moderate;

  const location = useLocation();

  useEffect(() => {
    if (lastAddedComment !== '' && commentsList.length > 0) {
      scrollToLocation(`comment${lastAddedComment}`);
    }
  }, [lastAddedComment]);

  useEffect(() => {
    if (
      commentsData &&
      location.hash.startsWith('#comment') &&
      commentsList.findIndex((item) => item.id === Number(location.hash.replace('#comment', ''))) >
        -1
    ) {
      setLastAddedComment(location.hash.replace('#comment', ''));
    }
  }, [commentsData, location.hash]);

  return (
    <>
      {commentsData.summary.can_comment !== undefined && (
        <CommentsWrapper>
          <div id='commentsTop'></div>
          <TitleRow Type='h3' tw='flex items-center top-[-1px] z-20' sticky RightBlock={RightBlock}>
            {pluralize(
              commentsList !== null ? commentsData.summary.comment_count : 0,
              'reaguursel',
            )}
          </TitleRow>
          {userCanModerate && <ModeratorButtons itemId={itemId} />}
          <hr tw='border-icons opacity-20 mb-2 md:mb-3' />
          {openComments && !userCanModerate && (
            <>
              <AddCommentButton />
              <hr tw='border-icons opacity-20 mb-2 md:mb-3' />
            </>
          )}
          <div tw='flex flex-col gap-2 md:gap-3 relative'>
            <InfiniteScrollCommentsList
              itemsPerPage={location.hash || showAllComments ? 999 : 10}
            />
            <div tw='flex mt-2 flex-col lg:mb-0' id='form'>
              <CommentForm />
            </div>
            {commentsList.length > 6 && (
              <>
                <hr tw='border-icons opacity-20 mb-2' />
                <GoToTopOfComments />
              </>
            )}
          </div>
        </CommentsWrapper>
      )}
    </>
  );
};
